import React from 'react';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    color?: string;
    size?: number;
};

const Cursor03Icon = ({
    color = 'currentColor',
    size = 24,
    strokeWidth = 2,
    strokeLinecap = 'round',
    strokeLinejoin = 'round',
    ...props
}: Props) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width={size} height={size} {...props}>
        <path
            stroke={color}
            strokeLinecap={strokeLinecap}
            strokeLinejoin={strokeLinejoin}
            strokeWidth={strokeWidth}
            d="M8.975 18.168 3.674 4.712c-.213-.54-.32-.81-.262-.983a.5.5 0 0 1 .316-.317c.173-.057.443.05.984.262l13.455 5.301c.435.172.653.257.74.397a.5.5 0 0 1 .055.408c-.047.158-.234.299-.608.58L15.5 12.5s3.106 3.168 5 5l-3 3-5-5-2.141 2.854c-.28.375-.421.562-.58.609a.5.5 0 0 1-.407-.055c-.14-.088-.226-.305-.397-.74"
        />
    </svg>
);
export { Cursor03Icon };
